export const PATH = '@recative/shell/path';
export const DATA_TYPE = '@recative/shell/data-type';
export const INDEX_ORDER = '@recative/shell/index-order';
export const PREFERRED_UPLOADERS = '@recative/shell/preferred-uploaders';
export const CONTAINER_COMPONENT = '@recative/shell/container-component';
export const REPORT_RESOURCE_VALIDATION = '@recative/shell/report-resource-validation';
export const ADDITIONAL_CONFIG = '@recative/shell/additional-config';
